/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_0ef613e0"]'><div :class='["modal-with-horizontal-icon-demo"]'><cube-modal ref="__mpx_ref_modal__" type="confirm" title="我是标题哟我是标题哟我是标题哟~" content="我是正文我是正文我是正文~" layout="horizontal" confirm-btn="确认" :mask-closable="(true)" :show-close-icon="(true)" @confirm='(e)=>__invoke(e, [["onConfirm"]])' @close='(e)=>__invoke(e, [["onClose"]])'><mpx-image slot="icon" src="https://ut-static.udache.com/webx/mpx-cube-ui/06UBoCw3t0hVzCurBpcKs.png" :class='["modal-image-icon"]'></mpx-image></cube-modal><cube-button @_click="onTap">modal-with-horizontal-icon</cube-button></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_0ef613e0"}'>
.modal-with-horizontal-icon-demo
  .modal-image-icon
    display block
    height 60px
    width 60px
    margin-left 27px
    margin-right 19px
    margin-bottom 15px
    margin-top 3px
    border-radius 50%
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_0ef613e0"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_0ef613e0"}
  /** script content **/
  require("./modal-with-horizontal-icon.mpx.js?isComponent&outputPath=components%2Fmodal-with-horizontal-icon0ef613e0%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./modal-with-horizontal-icon.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fmodal-with-horizontal-icon0ef613e0%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_0ef613e0"],
    ctorType: "component",
    outputPath: "components/modal-with-horizontal-icon0ef613e0/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/modal/index.mpx?isComponent&outputPath=components%2Findex317b3b4c%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image?isComponent"), {__mpxBuiltIn: true})},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>